import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useGameData = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const urlType = searchParams.get('urlType');
    const preview = searchParams.get('preview');
    const gameName = searchParams.get('gameName');
    const gameCode = searchParams.get('gameCode');
    const mobileGameCode = searchParams.get('mobileGameCode');
    const integrationType = searchParams.get('integrationType');
    const liveLaunchAlias = searchParams.get('liveLaunchAlias');
    const urlCustomParameters = searchParams.get('urlCustomParameters');
    const additionalQueryString = searchParams.get('additionalQueryString');

    return useMemo(() => ({
        urlType,
        preview,
        gameName,
        gameCode,
        mobileGameCode,
        integrationType,
        liveLaunchAlias,
        urlCustomParameters,
        additionalQueryString
    }), [
        urlType,
        preview,
        gameName,
        gameCode,
        mobileGameCode,
        integrationType,
        liveLaunchAlias,
        urlCustomParameters,
        additionalQueryString
    ]);
};
